import { render, staticRenderFns } from "./stop-case-import-details.vue?vue&type=template&id=6afd8b3e&scoped=true"
import script from "./stop-case-import-details.vue?vue&type=script&lang=ts"
export * from "./stop-case-import-details.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afd8b3e",
  null
  
)

export default component.exports